var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferencesDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 437,
    x2: 256,
    y2: 79,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2AF598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009EFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M177.126,435H89.543l7.216-25.455C103.812,384.665,115,339.712,115,325 c0-3.591-0.107-6.216-0.251-8.119c-30.471-1.311-58.917-13.961-80.375-35.812C12.208,258.497,0,228.641,0,197 C0,130.832,53.832,77,120,77s120,53.832,120,120c0,135.148-54.68,224.797-57.007,228.547L177.126,435z M142.059,395h12.13 C167.164,369.834,200,296.32,200,197c0-44.112-35.888-80-80-80s-80,35.888-80,80c0,43.262,35.176,79.141,78.413,79.979l0.878,0.022 c17.538,0.099,26.09,9.106,30.178,16.669C154.06,302.162,155,312.336,155,325C155,340.959,147.806,372.416,142.059,395z  M119.936,317.042L119.936,317.042L119.936,317.042z M449.126,435h-87.583l7.216-25.455C375.812,384.665,387,339.712,387,325 c0-3.591-0.107-6.216-0.251-8.119c-30.471-1.311-58.917-13.961-80.375-35.812C284.208,258.497,272,228.641,272,197 c0-66.168,53.832-120,120-120s120,53.832,120,120c0,135.148-54.68,224.797-57.007,228.547L449.126,435z M414.059,395h12.13 C439.164,369.834,472,296.32,472,197c0-44.112-35.888-80-80-80s-80,35.888-80,80c0,43.262,35.176,79.141,78.413,79.979l0.878,0.022 c17.538,0.099,26.09,9.106,30.178,16.669C426.06,302.162,427,312.336,427,325C427,340.959,419.806,372.416,414.059,395z  M391.936,317.042L391.936,317.042L391.936,317.042z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferencesDark);
export default __webpack_public_path__ + "static/media/ReferencesDark.1da61488.svg";
export { ForwardRef as ReactComponent };